import axios from "./configs/axiosConfig";

export const getStLocationSearchWithDealer = async (dealerid, key, type) => {
  const url = `stlocations/search/${dealerid}?key=${key}&type=${type}`;
  return await axios.get(url);
};
